import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_DETAIL_CHANGED,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_LOAN_DETAIL_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from '../../actions/types'

const INIT_STATE = {
  repaymentYear: 10,
  repaymentFrequency: 'monthly',
  offsetAccount: false
}

const prefilledState = (newState) => {
  const repaymentYear = newState.repaymentYear || INIT_STATE.repaymentYear
  const repaymentFrequency = newState.repaymentFrequency || INIT_STATE.repaymentFrequency
  const offsetAccount = newState.offsetAccount || INIT_STATE.offsetAccount

  return {
    repaymentYear,
    repaymentFrequency,
    offsetAccount,
  }
}

const settings = (state = INIT_STATE, {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (payload.applicationFlow.loanDetail !== undefined ) {
        const newState = payload.applicationFlow.loanDetail.settings
        return prefilledState(newState)
      } else {
        return state
      }

    case UPDATE_COMMITMENTS_SUCCESS:
    case UPDATE_ASSETS_SUCCESS:
    case UPDATE_LOAN_DETAIL_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.loanDetail !== undefined ) {
        const newState = payload.loanDetail.settings
        return prefilledState(newState)
      } else {
        return state
      }

    case LOAN_DETAIL_CHANGED:
      return { ...state, ...payload.setting }
    default:
      return state;
  }
}

export default settings;
